import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import SocialPage from "./pages/SocialPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/connect" element={<SocialPage />} />
          <Route path="/social" element={<SocialPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
